import { Sun, Moon, Monitor } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme, type Theme } from "@/lib/theme";

const next: Record<Theme, Theme> = { light: "dark", dark: "system", system: "light" };
const icons: Record<Theme, React.ElementType> = { light: Sun, dark: Moon, system: Monitor };
const labels: Record<Theme, string> = { light: "Light", dark: "Dark", system: "System" };

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const Icon = icons[theme];
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setTheme(next[theme])}
      title={`Theme: ${labels[theme]} — click to switch`}
      className="gap-1.5 text-muted-foreground hover:text-foreground"
    >
      <Icon className="w-4 h-4" />
      <span className="text-xs hidden sm:inline">{labels[theme]}</span>
    </Button>
  );
}
